export const C_SearchBox = {
    MAX_USER_ITEMS: 3,
    MAX_PAGE_ITEMS: 5,
    MIN_SEARCH_QUERY_LEN: 2,
    MIN_REQUEST_TIME_GAP: 2000,
    HOLD_ON_TIME_GAP: 300,
};
